<div class="main-container">
    <app-embedded-loader [show]="showLoader"></app-embedded-loader>

    <div class="title-text">All Documents</div>
    <div class="section">

        <div class="filter-container">


            <div class="search-container">
                <input type="text" [(ngModel)]="searchParam"
                    placeholder="Search all documents by Buyer, RFQ reference No" class="search-input">
                <button class="search-button" (click)="onSearch()">
                    <mat-icon>search</mat-icon> Search
                </button>
            </div>

            <mat-form-field appearance="outline" style="margin-top:10px">
                <mat-label>Select Columns</mat-label>
                <mat-select>
                    <mat-option *ngFor="let col of columns" (click)="toggleColumn(col)">
                        <mat-checkbox [checked]="col.visible">{{ col.name }}</mat-checkbox>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <button class="export-button" (click)="exportAll()" style="margin-bottom:10px">
                <mat-icon>cloud_download</mat-icon>
            </button>
        </div>

        <div class="filter-section">
            <span
                style="padding-left: 16px; padding-top: 16px; margin-bottom: 32px; font-weight: bold; display: flex; justify-content: space-between; padding-right: 20px;"
                (click)="toggleVisibility()">

                <div>Filters</div>
                <div>Search based on filters</div>
                <mat-icon>
                    {{ isFilterExpand ? 'expand_less' : 'expand_more' }}
                </mat-icon>
            </span>

            <div *ngIf="isFilterExpand">
                <div class="filter-content">
                    <mat-form-field appearance="fill" class="dropdown" style="width: 100%;">
                        <!-- <mat-label>Filter Key</mat-label> -->
                        <mat-select [value]="'all'">
                            <mat-option value="all">All</mat-option>
                            <mat-option value="open">Open</mat-option>
                            <mat-option value="closed">Closed</mat-option>

                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="dropdown" style="width: 100%;">
                        <!-- <mat-label>Filter Key</mat-label> -->
                        <mat-select [value]="'rfq'">
                            <mat-option value="all">All</mat-option>
                            <mat-option value="rfq">RFQ</mat-option>
                            <mat-option value="qot">QOT</mat-option>
                            <mat-option value="ord">ORD</mat-option>
                            <mat-option value="poc">POC</mat-option>

                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="fill" class="dropdown" style="width: 100%;">
                        <!-- <mat-label>Filter Key</mat-label> -->
                        <mat-select [value]="'all'">
                            <mat-option value="all">All</mat-option>
                            <mat-option value="acknowledged">Acknowledged</mat-option>
                            <mat-option value="declined">Declined</mat-option>
                            <mat-option value="lost">Lost</mat-option>
                            <mat-option value="lapsed">Lapsed</mat-option>
                            <mat-option value="unactioned">Unactioned</mat-option>

                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="full-width" color="accent">
                        <mat-label>From Date</mat-label>
                        <input matInput [matDatepicker]="fromDatepicker" [(ngModel)]="fromDate" />
                        <mat-datepicker-toggle matSuffix [for]="fromDatepicker"
                            [disabled]="false"></mat-datepicker-toggle>
                    </mat-form-field>
                    <mat-datepicker #fromDatepicker></mat-datepicker>

                    <mat-form-field class="full-width" color="accent">
                        <mat-label>To Date</mat-label>
                        <input matInput [matDatepicker]="toDatepicker" [(ngModel)]="toDate" />
                        <mat-datepicker-toggle matSuffix [for]="toDatepicker"
                            [disabled]="false"></mat-datepicker-toggle>
                    </mat-form-field>
                    <mat-datepicker #toDatepicker></mat-datepicker>
                </div>
                <div class="button-container">
                    <button type="submit" class="search-btn" (click)="onSearch()">
                        <mat-icon>search</mat-icon>
                    </button>
                    <button type="button" class="close-button" (click)="cancelFilter()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </div>


            </div>

        </div>

        <div class="filter-section" style="display: flex; align-items: center;" *ngIf="this.selectedRfq.length >0 ">

            <div style="margin-left: 10px; margin-right: 20px;"><b>Selected {{this.selectedRfq.length}} of
                    {{this.totalRecords}} RFQs</b></div>

            <button mat-icon-button mat-sm-button color="primary" class="mr-1" matTooltipClass="mat-tooltip-custom"
                matTooltip="Archive" matTooltipPosition="below" (click)="rfqOperation('archive')">
                <mat-icon>archive</mat-icon>
            </button>

            <!-- <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                matTooltipClass="mat-tooltip-custom" 
                matTooltip="Urchive" matTooltipPosition="below" (click)="rfqOperation('unarchive')">
                <mat-icon>unarchive</mat-icon>
           </button> -->

            <button mat-icon-button mat-sm-button color="primary" class="mr-1" matTooltipClass="mat-tooltip-custom"
                matTooltip="Mark as opened" matTooltipPosition="below" (click)="rfqOperation('markAsOpen')">
                <mat-icon>mail_outline</mat-icon>
            </button>

            <button mat-icon-button mat-sm-button color="primary" class="mr-1" matTooltipClass="mat-tooltip-custom"
                matTooltip="Mark as unopened" matTooltipPosition="below" (click)="rfqOperation('markAsUnopen')">
                <mat-icon>email</mat-icon>
            </button>

        </div>


        <ngx-datatable #supplierTable class="material expandable bg-light supplier-table sup-tbl" [rows]="documentData"
            [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [columnMode]="'force'" [limit]="limit"
            [count]="totalRecords" [externalPaging]="true" [externalSorting]="true" [scrollbarH]="true"
            [offset]="offset" (page)="onPageChange($event)" (sort)="onSort($event)">

            <!-- <ngx-datatable-column name="Buyer" prop="companyName" [flexGrow]="1" *ngIf="isColumnVisible('companyName')" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                   
                </ng-template>
            </ngx-datatable-column> -->

            <ngx-datatable-column [sortable]="false">
                <ng-template ngx-datatable-header-template>
                    <input type="checkbox" [checked]="this.selectedRfq.length == this.documentData.length"
                        (change)="toggleSelectAll($event,'active')" />
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <input type="checkbox" [checked]="isChecked(row.supplierRfqDetailsId,'active')"
                        (change)="selectDeselectRfq($event, row.supplierRfqDetailsId,'active')" />
                </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column name="Buyer" prop="companyName" [flexGrow]="1" *ngIf="isColumnVisible('companyName')"
                [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.companyName || '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Document Type" [flexGrow]="1" prop="docType" *ngIf="isColumnVisible('docType')"
                [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    RFQ
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Reference" [flexGrow]="1" prop="rfqRefNumber"
                *ngIf="isColumnVisible('rfqRefNumber')" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        class="rfq-link"
                        style="color: #1a73e8"
                        [routerLink]="['/dashboard/quote/rfq-details', row.rfqId || row.rfqDetailsId]"
                        matTooltip="{{ row.rfqRefNumber }}"
                        matTooltipPosition="below"
                    >
                        {{ row.rfqRefNumber }}
                    </a>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Approved By" prop="approvedBy" [flexGrow]="1"
                *ngIf="isColumnVisible('approvedBy')" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.approvedBy || '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Status" [flexGrow]="1" prop="docStatus" *ngIf="isColumnVisible('docStatus')"
                [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="row.docStatus" class="status-label status-{{ row.docStatus }}" (click)="openRfqDetails(row.rfqDetailsId)">
                        {{ row.docStatus }}
                    </span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Date" [flexGrow]="1" prop="rfqDate" *ngIf="isColumnVisible('rfqDate')"
                [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.rfqDate | date:'dd/MM/yyyy' }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Quote before date" prop="quotedByDate" [flexGrow]="1"
                *ngIf="isColumnVisible('quotedByDate')" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.quotedByDate || '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Vessel" prop="vesselName" [flexGrow]="1" *ngIf="isColumnVisible('vesselName')"
                [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.vesselName || '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Port Country" prop="portCountry" [flexGrow]="1"
                *ngIf="isColumnVisible('portCountry')" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.portCountry || '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Port Name" prop="portName" [flexGrow]="1" *ngIf="isColumnVisible('portName')"
                [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.portName || '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Buyer Contact Name" prop="contact" [flexGrow]="1"
                *ngIf="isColumnVisible('contact')" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.contact || '-'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Delivery date" prop="requestDeliveryDate" [flexGrow]="1"
                *ngIf="isColumnVisible('requestDeliveryDate')" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{row.requestDeliveryDate | date:'dd/MM/yyyy'}}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Action" [flexGrow]="1">
                <ng-template let-column="column" ngx-datatable-header-template><span>Action</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <button *ngIf="row.RFQpath" mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom"
                        (click)="downloadRfq(row.rfqDetailsId, row.supplierId, row.rfqRefNumber)" matTooltip="Download"
                        matTooltipPosition="below">
                        <mat-icon>download</mat-icon>
                    </button>
                    <button *ngIf="row.RFQpath" mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" (click)="OpenRfq(row.rfqDetailsId, row.supplierId)"
                        matTooltip="Preview" matTooltipPosition="below">
                        <mat-icon>visibility</mat-icon>
                    </button>

                    <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" (click)="openRfqDetails(row.rfqDetailsId)"
                        matTooltip="Open" matTooltipPosition="below">
                        <mat-icon>launch</mat-icon>
                   </button>

                    <!-- <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" (click)="OpenSupplierProductPopUp(false, null, row.userId)" matTooltip="Add Product" matTooltipPosition="below">
                        <mat-icon>add_card</mat-icon>
                    </button>
                    
                    <button [mdePopoverTriggerFor]="appPopover"
                        mdePopoverTriggerOn="click" [mdePopoverBackdropCloseOnClick]="false" mat-icon-button
                        #popoverTrigger="mdePopoverTrigger">
                        <mat-icon color="warn">
                            delete</mat-icon>
                    </button>
                    <mde-popover #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
                        <mat-card class="mat-card-popover">
                            <mat-card-header class="mat-card-header-popover">
                                <mat-card-title>Are you sure?</mat-card-title>
                            </mat-card-header>

                            <mat-card-actions
                                class="mat-card-action-popover display-flex justify-content-space-between">
                                <button class="mat-action-btn popover_action cancel" mat-raised-button>Cancel</button>
                                <button class="mat-action-btn popover_action" mat-raised-button
                                    color="warn">Delete</button>
                            </mat-card-actions>
                        </mat-card>
                    </mde-popover> -->
                </ng-template>
            </ngx-datatable-column>
            <!-- <ngx-datatable-column name="Profile" [flexGrow]="1">
                <ng-template let-column="column" ngx-datatable-header-template><span>Profile</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" (click)="OpenSupplierProfilePopup(null, row.userId, row.companyId||0)" matTooltip="Edit" matTooltipPosition="below">
                        <mat-icon>person</mat-icon>
                    </button>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Preview" [flexGrow]="1">
                <ng-template let-column="column" ngx-datatable-header-template><span>Preview</span>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" (click)="OpenSupplierPreviewPopup(null, row.userId, row.companyId||0)" matTooltip="Edit" matTooltipPosition="below">
                        <mat-icon>visibility</mat-icon>
                    </button>
                </ng-template>
            </ngx-datatable-column>  -->

        </ngx-datatable>

        <div class="archive">

            <div class="title-text" style="margin-bottom: 30px; display: flex; justify-content: space-between;" (click)="toggleArchived()">
                Archived Documents
                <mat-icon>
                    {{ isArchivedExpand ? 'expand_less' : 'expand_more' }}
                </mat-icon>
            </div>

            <ng-container *ngIf="isArchivedExpand">

                <div class="filter-section" style="display: flex; align-items: center;"
                *ngIf="this.selectedArchivedRfq.length >0 ">

                    <div style="margin-left: 10px; margin-right: 20px;"><b>Selected {{this.selectedArchivedRfq.length}}
                            of {{this.archivedTotalRecords}} archived RFQs</b></div>

                    <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" matTooltip="Urchive" matTooltipPosition="below"
                        (click)="rfqOperation('unarchive')">
                        <mat-icon>unarchive</mat-icon>
                    </button>

                    <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" matTooltip="Mark as opened" matTooltipPosition="below"
                        (click)="rfqOperation('markAsOpen')">
                        <mat-icon>mail_outline</mat-icon>
                    </button>

                    <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                        matTooltipClass="mat-tooltip-custom" matTooltip="Mark as unopened" matTooltipPosition="below"
                        (click)="rfqOperation('markAsUnopen')">
                        <mat-icon>email</mat-icon>
                    </button>



                </div>

                <ngx-datatable #supplierTable class="material expandable bg-light supplier-table sup-tbl"
                    [rows]="archivedDocumentData" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'"
                    [columnMode]="'force'" [limit]="archivedLimit" [count]="archivedTotalRecords"
                    [externalPaging]="true" [externalSorting]="true" [scrollbarH]="true" [offset]="archivedOffset"
                    (page)="onArchivedPageChange($event)" (sort)="onArchivedSort($event)">

                    <!-- <ngx-datatable-column name="Buyer" prop="companyName" [flexGrow]="1" *ngIf="isColumnVisible('companyName')" [minWidth]="150">
            <ng-template let-row="row" ngx-datatable-cell-template>
               
            </ng-template>
        </ngx-datatable-column> -->

                    <ngx-datatable-column [sortable]="false">
                        <ng-template ngx-datatable-header-template>
                            <input type="checkbox"
                                [checked]="this.selectedArchivedRfq.length == this.archivedDocumentData.length"
                                (change)="toggleSelectAll($event,'archived')" />
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <input type="checkbox" [checked]="isChecked(row.supplierRfqDetailsId,'archived')"
                                (change)="selectDeselectRfq($event, row.supplierRfqDetailsId,'archived')" />
                        </ng-template>
                    </ngx-datatable-column>


                    <ngx-datatable-column name="Buyer" prop="companyName" [flexGrow]="1"
                        *ngIf="isColumnVisible('companyName')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.companyName || '-'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Document Type" [flexGrow]="1" prop="docType"
                        *ngIf="isColumnVisible('docType')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            RFQ
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Reference" [flexGrow]="1" prop="rfqRefNumber"
                        *ngIf="isColumnVisible('rfqRefNumber')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a
                                class="rfq-link"
                                style="color: #1a73e8"
                                [routerLink]="['/dashboard/quote/rfq-details', row.rfqId || row.rfqDetailsId]"
                                matTooltip="{{ row.rfqRefNumber }}"
                                matTooltipPosition="below"
                            >
                                {{ row.rfqRefNumber }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Approved By" prop="approvedBy" [flexGrow]="1"
                        *ngIf="isColumnVisible('approvedBy')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.approvedBy || '-'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Status" [flexGrow]="1" prop="docStatus"
                        *ngIf="isColumnVisible('docStatus')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span *ngIf="row.docStatus" class="status-label status-{{ row.docStatus }}">
                                {{ row.docStatus }}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Date" [flexGrow]="1" prop="rfqDate" *ngIf="isColumnVisible('rfqDate')"
                        [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.rfqDate | date:'dd/MM/yyyy' }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Quote before date" prop="quotedByDate" [flexGrow]="1"
                        *ngIf="isColumnVisible('quotedByDate')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.quotedByDate || '-'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Vessel" prop="vesselName" [flexGrow]="1"
                        *ngIf="isColumnVisible('vesselName')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.vesselName || '-'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Port Country" prop="portCountry" [flexGrow]="1"
                        *ngIf="isColumnVisible('portCountry')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.portCountry || '-'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Port Name" prop="portName" [flexGrow]="1"
                        *ngIf="isColumnVisible('portName')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.portName || '-'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Buyer Contact Name" prop="contact" [flexGrow]="1"
                        *ngIf="isColumnVisible('contact')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.contact || '-'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Delivery date" prop="requestDeliveryDate" [flexGrow]="1"
                        *ngIf="isColumnVisible('requestDeliveryDate')" [minWidth]="150">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{row.requestDeliveryDate | date:'dd/MM/yyyy'}}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Action" [flexGrow]="1">
                        <ng-template let-column="column" ngx-datatable-header-template><span>Action</span>
                        </ng-template>
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button *ngIf="row.RFQpath" mat-icon-button mat-sm-button color="primary" class="mr-1"
                                matTooltipClass="mat-tooltip-custom"
                                (click)="downloadRfq(row.rfqDetailsId, row.supplierId, row.rfqRefNumber)"
                                matTooltip="Download" matTooltipPosition="below">
                                <mat-icon>download</mat-icon>
                            </button>
                            <button *ngIf="row.RFQpath" mat-icon-button mat-sm-button color="primary" class="mr-1"
                                matTooltipClass="mat-tooltip-custom" (click)="OpenRfq(row.rfqDetailsId, row.supplierId)"
                                matTooltip="Preview" matTooltipPosition="below">
                                <mat-icon>visibility</mat-icon>
                            </button>

                            <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                                matTooltipClass="mat-tooltip-custom" (click)="openRfqDetails(row.rfqDetailsId)"
                                matTooltip="Open" matTooltipPosition="below">
                                <mat-icon>launch</mat-icon>
                            </button>

                            <!-- <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                    matTooltipClass="mat-tooltip-custom" (click)="OpenSupplierProductPopUp(false, null, row.userId)" matTooltip="Add Product" matTooltipPosition="below">
                    <mat-icon>add_card</mat-icon>
                </button>
                
                <button [mdePopoverTriggerFor]="appPopover"
                    mdePopoverTriggerOn="click" [mdePopoverBackdropCloseOnClick]="false" mat-icon-button
                    #popoverTrigger="mdePopoverTrigger">
                    <mat-icon color="warn">
                        delete</mat-icon>
                </button>
                <mde-popover #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
                    <mat-card class="mat-card-popover">
                        <mat-card-header class="mat-card-header-popover">
                            <mat-card-title>Are you sure?</mat-card-title>
                        </mat-card-header>

                        <mat-card-actions
                            class="mat-card-action-popover display-flex justify-content-space-between">
                            <button class="mat-action-btn popover_action cancel" mat-raised-button>Cancel</button>
                            <button class="mat-action-btn popover_action" mat-raised-button
                                color="warn">Delete</button>
                        </mat-card-actions>
                    </mat-card>
                </mde-popover> -->
                        </ng-template>
                    </ngx-datatable-column>
                    <!-- <ngx-datatable-column name="Profile" [flexGrow]="1">
            <ng-template let-column="column" ngx-datatable-header-template><span>Profile</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                    matTooltipClass="mat-tooltip-custom" (click)="OpenSupplierProfilePopup(null, row.userId, row.companyId||0)" matTooltip="Edit" matTooltipPosition="below">
                    <mat-icon>person</mat-icon>
                </button>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Preview" [flexGrow]="1">
            <ng-template let-column="column" ngx-datatable-header-template><span>Preview</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                    matTooltipClass="mat-tooltip-custom" (click)="OpenSupplierPreviewPopup(null, row.userId, row.companyId||0)" matTooltip="Edit" matTooltipPosition="below">
                    <mat-icon>visibility</mat-icon>
                </button>
            </ng-template>
        </ngx-datatable-column>  -->

                </ngx-datatable>

            </ng-container>
        </div>
        <!-- <mat-card style="width: 400px;">
        <mat-calendar></mat-calendar>
      </mat-card> -->
    </div>
